module.exports = __webpack_public_path__ + "img/xcb-subject-banner.4d13b86f.jpg";